import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
      <h2>Introduction</h2>
      <p>
          Hadyn Stimpson is a Licensed Advanced Substance Use Disorder Counselor and Associate Master Addiction Counselor with nearly 5 years of experience working with clients in addiction recovery. 
        </p>
        <p>
          He has worked in residential and outpatient settings providing group and individual counseling for clients with substance use and co-occurring disorders such aa PTSD, depression, and anxiety disorders. While in graduate school he spent 2 and half years working in a teen treatment setting. 
        </p>
        <p>
          In addition to continuing education on trauma focused CBT and ACT he has devoted 6 years to formal education on human psychology and counseling approaches and is licensed to provide mental health therapy.        
        </p>

        <br />
        <br />
      </Wrap>
    </>
  );
};

export default Content;
